import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('tanyamu', ['qiscus']),
    msgService: {
      get () {
        return this.$store.state.notification.msgService
      },
      set (value) {
        this.$store.commit('notification/SET_MSG_SERVICE', value)
      }
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('storage/logoutRemoveStorage')
      this.$store.commit('user/CHANGE_IS_LOGIN', false)
      // you can use promise from v1.1.0 also
      this.$store.commit('user/SET_IS_CIKAL', false)
      this.$store.commit('login/SET_EMAIL', '')
      this.$store.commit('user/SET_RESEND_COUNTER', 0)

      this.$router.push('/?logout=1')

      // WIP: will delete after testing by QA
      //* reset programmu
      // const myProfile = this.userInfo
      // let payload = {}
      // payload.id = myProfile.id
      // payload.name = myProfile.name
      // payload.avatar = myProfile.avatar
      // payload.year_level = myProfile.year_level
      // this.$store.commit('user/CHANGE_USER', payload)
      if (this.qiscus) {
        this.$store.dispatch('tanyamu/logoutQiscus')
      }

      if (this.msgService) {
        this.msgService.deleteTokenAsync()
      }
    }
  }
}
